import { defineFcm } from '../shared/factory';

export const FCM_PETITIONS_WITH_BLOCKED_SIGNATURE_EXPORT = defineFcm('petitions_with_blocked_signature_export')
	.asString()
	.withDefault(undefined)
	.toConfig();
